import {createApi, fetchBaseQuery} from '@reduxjs/toolkit/query/react'
import {refreshBaseQuery} from './refreshBaseQuery'
const API_URL = process.env.REACT_APP_API_URL

export const knowledgeServiceApi = createApi({
  reducerPath: 'knowledgeServiceApi',
  baseQuery: refreshBaseQuery,
  tagTypes: ['Knowledge'],
  endpoints: (builder) => ({
    createKnowledge: builder.mutation({
      query: (data) => ({
        url: `${API_URL}/knowledge`,
        method: 'POST',
        body: data,
      }),
    }),
    findOneKnowledge: builder.query({
      query: () => ({
        url: `${API_URL}/knowledge`,
        method: 'GET',
      }),
      providesTags: ['Knowledge'],
    }),
    getAllKnowledge: builder.query({
      query: ({page, keywords}) => ({
        url: `${API_URL}/knowledge?page=${page}&keywords=${keywords}`,
        method: 'GET',
      }),
      providesTags: ['Knowledge'],
    }),
    updateKnowledgeStatus: builder.mutation({
      query: ({public_id, is_active}) => ({
        url: `${API_URL}/knowledge/${public_id}/is_active`,
        method: 'PATCH',
        body: {is_active},
      }),
      invalidatesTags: ['Knowledge'],
    }),
    updateKnowledge: builder.mutation({
      query: ({data, public_id}) => ({
        url: `${API_URL}/knowledge/${public_id}`,
        method: 'PATCH',
        body: data,
      }),
      invalidatesTags: ['Knowledge'],
    }),
    deleteKnowledge: builder.mutation({
      query: ({public_id}) => ({
        url: `${API_URL}/knowledge/${public_id}`,
        method: 'DELETE',
      }),
    }),
  }),
})

export const {
  useCreateKnowledgeMutation,
  useUpdateKnowledgeMutation,
  useGetAllKnowledgeQuery,
  useUpdateKnowledgeStatusMutation,
  useDeleteKnowledgeMutation,
  useFindOneKnowledgeQuery,
} = knowledgeServiceApi
